export default __webpack_public_path__ + "static/media/Swift_mob.3a4c5cdd.png";